import { PageTitle } from '_metronic/layout/core'

import { ClientSideTable } from 'Presentation/Components/Table'
// import StepChip from 'Presentation/Components/StepChip'
import KumopackStepper from 'Presentation/Components/KumopackStepper'

import useViewModel from './ViewModel'
import moment from 'moment'
import clsx from 'clsx'

//////////
// View //
//////////

const InquiryDetailView: React.FC = () => {
	const {
		confirm,
		reject,
		back,
		data,
		tableData,
		expiredAt,
		TABLE_COLUMNS,
		isLoading,
		isSubmitting,
		isRejected,
		canMakeDecision,
	} = useViewModel()

	return (
		<ViewPageTitle>
			<div className="row gy-5">
				<div className="col-12">
					<div className="card border-kumopack-grey-200">
						{/* Header */}
						<div className="card-header">
							<div className="card-title">
								<h4 className="text-kumopack-grey-900 fw-bold mb-0">
									หมายเลขที่ใบคำร้อง: <span className="fw-normal">{data?.code}</span>
								</h4>
							</div>

							{/* <div className="card-toolbar">
								<StepChip stepLabel={data?.statusTitleTh ?? ''} />
							</div> */}
						</div>

						<div className="card-body">
							<div className="row gy-5">
								{/* Stepper */}
								{!isRejected && (
									<div className="col-12">
										<KumopackStepper
											color="secondary"
											items={[
												{
													label: 'ส่งคำขอ',
													status: 'active',
													description: '-',
												},
												{
													label: 'ส่งใบเสนอราคา',
													status: 'pending',
													description: '-',
												},
												{
													label: 'เลือกผู้ผลิต',
													status: 'pending',
													description: '-',
												},
											]}
										/>
									</div>
								)}

								{/* OEM Header */}
								{!isRejected && (
									<div className="col-12">
										<div className="row g-3 align-items-center">
											<div className="col-8">
												{/* <h4
												className="d-inline-block text-kumopack-grey-900 fw-bold me-2"
												style={{ marginInline: 0, marginBlock: 0 }}>
												เลขที่คำร้อง: ABC123456
											</h4>
											<span
												className="d-inline-block badge badge-kumopack-secondary-50 text-kumopack-secondary-700"
												style={{ borderRadius: '16px' }}>
												New Orders
											</span> */}
											</div>
											<div className="col-4 text-end">
												{data?.oemRequest?.expiredAt && (
													<button
														className={clsx('d-inline-block btn btn-sm  fw-bold', {
															'btn-kumopack-error-50 text-kumopack-error-700':
																expiredAt === 'หมดอายุ',
															'btn-muted text-kumopack-grey-600': expiredAt === null,
															'btn-kumopack-primary-700 text-kumopack-base-white':
																typeof expiredAt === 'number',
														})}>
														{expiredAt === null
															? ''
															: typeof expiredAt === 'number'
															? `เหลือเวลาอีก ${expiredAt} ชม.`
															: expiredAt}
													</button>
												)}
												{/* <button className="btn btn-icon btn-custom btn-active-light rounded-circle">
												<img
													src="/media/icons/kumopack/dots-vertical.png"
													alt="Dot Vertical Icon"
													width={20}
													height={20}
												/>
											</button> */}
											</div>
										</div>
									</div>
								)}

								{/* OEM Detail */}
								<div className="col-12">
									<div className="card border border-kumopack-grey-200">
										<div className="card-header">
											<div className="card-title">
												<h4
													className="d-inline-block text-kumopack-grey-900 fw-bold me-2"
													style={{ marginInline: 0, marginBlock: 0 }}>
													All Orders
												</h4>
												<span
													className="d-inline-block badge badge-kumopack-secondary-50 text-kumopack-secondary-700"
													style={{ borderRadius: '16px' }}>
													{data.quantities.length} items
												</span>
											</div>
										</div>

										<div className="card-body p-0">
											<ClientSideTable
												isLoading={isLoading}
												data={tableData}
												columns={TABLE_COLUMNS}
												items_per_page={9999}
											/>

											<hr
												style={{
													background: 'transparent',
													borderBottom: '1px solid #CCC',
													borderTop: 0,
													borderLeft: 0,
													borderRight: 0,
													margin: 0,
												}}
											/>

											<div className="text-kumopack-grey-700 p-5">
												สร้างเมื่อวันที่ {moment(data?.createdAt).format('DD-MM-YYYY')}
											</div>
										</div>
									</div>
								</div>

								{/* Confirm Button */}
								<div className="col-12 text-end">
									<div className="d-flex flex-row justify-content-between">
										<button
											className="btn btn-sm white-button text-kumopack-grey-700 fw-bold"
											onClick={back}
											disabled={isSubmitting}>
											ย้อนกลับ
										</button>

										{canMakeDecision && (
											<div className="d-flex flex-row" style={{ gap: '8px' }}>
												<button
													className="btn btn-sm btn-kumopack-error-500 text-kumopack-base-white fw-bold"
													onClick={reject}
													disabled={isSubmitting || isLoading}>
													ปฎิเสธใบคำร้อง
												</button>

												<button
													className="btn btn-sm btn-kumopack-success-600 text-kumopack-base-white fw-bold"
													onClick={confirm}
													id="inquiry-confirm-button"
													disabled={isSubmitting || isLoading}>
													<img
														className="me-1"
														src="/media/icons/kumopack/message-chat-circle-white.svg"
														alt="White Message Icon"
													/>
													ตอบรับใบคำร้อง
												</button>
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ViewPageTitle>
	)
}

/////////////////////
// View Page Title //
/////////////////////

const ViewPageTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<>
			<PageTitle
				breadcrumbs={[
					{
						title: 'OEM',
						path: '/oem',
						isActive: false,
						isSeparator: false,
					},
					{
						title: 'OEM Details',
						path: '#',
						isActive: true,
						isSeparator: false,
					},
				]}>
				รายละเอียดใบคำร้อง
			</PageTitle>

			{children}
		</>
	)
}

export default InquiryDetailView
